<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-校园服务-修改
    -->
  <el-dialog
    title="修改校园服务"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >
        <div class="common-form">修改校园服务</div>

        <el-form-item label="名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入校园服务名称"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <!-- 服务类型选择框 -->
        <el-form-item label="服务类型" prop="status">
          <el-select
            v-model="form.status"
            placeholder="请选择服务类型"
            class="max-w460"
            @change="handleServiceTypeChange"
          >
            <el-option label="取快递" value="取快递"></el-option>
            <el-option label="取奶茶咖啡" value="取奶茶咖啡"></el-option>
            <el-option label="帮我买" value="帮我买"></el-option>
            <el-option label="搬运服务" value="搬运服务"></el-option>
            <el-option label="鲜花驿站" value="鲜花驿站"></el-option>
          </el-select>
        </el-form-item>

        <!-- 动态显示的字段 - 根据服务类型显示 -->
        <!-- 取快递 -->
        <template v-if="form.status === '取快递'">
          <el-form-item label="商品类目" prop="goodsList">
            <!-- 每组两个输入框 -->
            <div
              v-for="(group, groupIndex) in form.goodsList"
              :key="groupIndex"
              class="input-group"
            >
              <div class="input-pair">
                <el-input
                  v-model="group[0].value"
                  placeholder="请输入商品类目"
                  class="multi-input"
                ></el-input>
                <el-input
                  v-model="group[1].value"
                  placeholder="请输入商品类目"
                  class="multi-input"
                ></el-input>
              </div>
              <el-button
                type="danger"
                icon="el-icon-minus"
                size="mini"
                @click="removeGroup('goodsList', groupIndex)"
                :disabled="form.goodsList.length <= 1"
              ></el-button>
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addGroup('goodsList')"
              class="add-btn"
            >
              添加商品类目组
            </el-button>
          </el-form-item>
          <el-form-item label="驿站地点" prop="dak">
            <el-input
              v-model="form.dak"
              placeholder="请输入驿站地点"
              class="max-w460"
            ></el-input>
          </el-form-item>
          <el-form-item label="送去哪" prop="destination">
            <el-input
              v-model="form.destination"
              placeholder="请输入目的地"
              class="max-w460"
            ></el-input>
          </el-form-item>
        </template>

        <!-- 取奶茶咖啡 -->
        <template v-if="form.status === '取奶茶咖啡'">
          <el-form-item label="品牌" prop="brand">
            <el-input
              v-model="form.brand"
              placeholder="请输入品牌"
              class="max-w460"
            ></el-input>
          </el-form-item>
          <el-form-item label="价格类目" prop="priceList">
            <!-- 每组两个输入框 -->
            <div
              v-for="(group, groupIndex) in form.priceList"
              :key="groupIndex"
              class="input-group"
            >
              <div class="input-pair">
                <el-input
                  v-model="group[0].value"
                  placeholder="请输入价格类目"
                  class="multi-input"
                ></el-input>
                <el-input
                  v-model="group[1].value"
                  placeholder="请输入价格类目"
                  class="multi-input"
                ></el-input>
              </div>
              <el-button
                type="danger"
                icon="el-icon-minus"
                size="mini"
                @click="removeGroup('priceList', groupIndex)"
                :disabled="form.priceList.length <= 1"
              ></el-button>
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addGroup('priceList')"
              class="add-btn"
            >
              添加价格类目组
            </el-button>
          </el-form-item>
        </template>

        <!-- 帮我买 -->
        <template v-if="form.status === '帮我买'">
          <el-form-item label="赏金" prop="money">
            <el-input
              v-model="form.money"
              placeholder="请输入赏金"
              class="max-w460"
            ></el-input>
          </el-form-item>
        </template>

        <!-- 搬运服务 -->
        <template v-if="form.status === '搬运服务'">
          <el-form-item label="搬运服务内容" prop="carry">
            <el-input
              v-model="form.carry"
              placeholder="请输入搬运服务内容"
              class="max-w460"
            ></el-input>
          </el-form-item>
        </template>

        <!-- 鲜花驿站 -->
        <template v-if="form.status === '鲜花驿站'">
          <el-form-item label="花的种类类目" prop="flowerList">
            <!-- 每组两个输入框 -->
            <div
              v-for="(group, groupIndex) in form.flowerList"
              :key="groupIndex"
              class="input-group"
            >
              <div class="input-pair">
                <el-input
                  v-model="group[0].value"
                  placeholder="请输入花的种类类目"
                  class="multi-input"
                ></el-input>
                <el-input
                  v-model="group[1].value"
                  placeholder="请输入花的种类类目"
                  class="multi-input"
                ></el-input>
              </div>
              <el-button
                type="danger"
                icon="el-icon-minus"
                size="mini"
                @click="removeGroup('flowerList', groupIndex)"
                :disabled="form.flowerList.length <= 1"
              ></el-button>
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addGroup('flowerList')"
              class="add-btn"
            >
              添加花的种类组
            </el-button>
          </el-form-item>
        </template>

        <!-- 所有服务类型都需要的公共字段 -->
        <el-form-item label="预计完成时间" prop="timeRange">
          <el-time-select
            v-model="form.timeRange[0]"
            placeholder="开始时间"
            :picker-options="{
              start: '08:00',
              step: '00:30',
              end: '18:00'
            }"
            @change="handleTimeChange"
          ></el-time-select>
          <span style="margin: 0 10px;">至</span>
          <el-time-select
            v-model="form.timeRange[1]"
            placeholder="结束时间"
            :picker-options="{
              start: '08:00',
              step: '00:30',
              end: '18:00'
            }"
            @change="handleTimeChange"
          ></el-time-select>
        </el-form-item>

        <el-form-item label="校园服务bannar：" prop="bannar">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bannar">
              <transition-group>
                <div v-for="(item, index) in form.bannar" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="bannar图片" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'bannar')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bannar')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="校园服务图片：" prop="image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="服务图片" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'album')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="校园服务介绍">
          <div class="edit_container">
            <Uediter
              v-model="form.intro"
              :text="ueditor.text"
              :config="ueditor.config"
              ref="ue"
            ></Uediter>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <!--提交按钮-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>

      <!--商品图片组件-->
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
      >
        上传图片
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import School_serviceApi from "@/api/school_service.js";
import Upload from "@/components/file/Upload";
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";

export default {
  components: {
    Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    return {
      // 是否上传图片
      isProductUpload: false,
      code: "album",

      // 富文本配置
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },

      // form表单数据
      form: {
        timeRange: ["", ""],
        name: "",
        code: "custom",
        status: "", // 服务类型
        image: [],
        sort: 50,
        intro: "",
        bannar: [],
        // 动态字段
        dak: "", // 驿站地点（取快递）
        brand: "", // 品牌（取奶茶咖啡）
        money: "", // 赏金（帮我买）
        carry: "", // 搬运服务内容（搬运服务）
        time_s: "", // 对接时间（公共）

        // 二维数组形式存储多组值，每组包含两个输入框
        goodsList: [[{ value: "" }, { value: "" }]], // 商品类目（取快递）
        priceList: [[{ value: "" }, { value: "" }]], // 价格类目（取奶茶咖啡）
        flowerList: [[{ value: "" }, { value: "" }]] // 花的种类类目（鲜花驿站）
      },

      loading: false,

      // 验证规则
      rules: {
        name: [
          { required: true, message: "请输入校园服务名称", trigger: "blur" }
        ],
        status: [
          { required: true, message: "请选择服务类型", trigger: "change" }
        ],
        timeRange: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
            validator: this.validateTimeRange
          }
        ]
        // 动态验证规则会根据服务类型变化
      },

      dialogVisible: false
    };
  },

  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },

  props: ["open_add", "school_service_id"],

  methods: {
    validateTimeRange(rule, value, callback) {
      if (!value[0]) {
        return callback(new Error("请选择开始时间"));
      }
      if (!value[1]) {
        return callback(new Error("请选择结束时间"));
      }
      if (value[0] >= value[1]) {
        return callback(new Error("结束时间必须晚于开始时间"));
      }
      callback();
    },

    // 添加新的一组输入框（两个）
    addGroup(listName) {
      this.form[listName].push([{ value: "" }, { value: "" }]);
    },

    // 移除一组输入框
    removeGroup(listName, groupIndex) {
      this.form[listName].splice(groupIndex, 1);
    },

    // 服务类型改变时的处理
    handleServiceTypeChange() {
      // 清空之前的表单数据
      this.clearDynamicFields();

      // 根据选择的服务类型添加对应的验证规则
      this.setDynamicRules();
    },

    // 清空动态字段
    clearDynamicFields() {
      // 重置为包含一组两个空输入框
      this.form.goodsList = [[{ value: "" }, { value: "" }]];
      this.form.priceList = [[{ value: "" }, { value: "" }]];
      this.form.flowerList = [[{ value: "" }, { value: "" }]];

      // 清空其他字段
      this.form.dak = "";
      this.form.brand = "";
      this.form.money = "";
      this.form.carry = "";
    },

    // 设置动态验证规则
    setDynamicRules() {
      // 重置所有动态规则
      Object.keys(this.rules).forEach(key => {
        if (
          [
            "goodsList",
            "dak",
            "brand",
            "priceList",
            "money",
            "carry",
            "flowerList",
            "time_s"
          ].includes(key)
        ) {
          delete this.rules[key];
        }
      });

      // 添加公共字段验证
      this.rules.time_s = [
        { required: true, message: "请输入对接时间", trigger: "blur" }
      ];

      // 自定义验证器：验证至少有一个有效输入
      const validateGroupArray = listName => (rule, value, callback) => {
        // 检查所有组中的所有输入框，是否至少有一个有值
        const hasValidValue = value.some(group =>
          group.some(item => item.value && item.value.trim() !== "")
        );

        if (!hasValidValue) {
          return callback(new Error(`请至少输入一个${rule.label}`));
        }
        callback();
      };

      // 根据服务类型添加对应验证规则
      switch (this.form.status) {
        case "取快递":
          this.rules.goodsList = [
            {
              required: true,
              label: "商品类目",
              validator: validateGroupArray("goodsList"),
              trigger: "change"
            }
          ];
          this.rules.dak = [
            { required: true, message: "请输入驿站地点", trigger: "blur" }
          ];
          break;
        case "取奶茶咖啡":
          this.rules.brand = [
            { required: true, message: "请输入品牌", trigger: "blur" }
          ];
          this.rules.priceList = [
            {
              required: true,
              label: "价格类目",
              validator: validateGroupArray("priceList"),
              trigger: "change"
            }
          ];
          break;
        case "帮我买":
          this.rules.money = [
            { required: true, message: "请输入赏金", trigger: "blur" }
          ];
          break;
        case "搬运服务":
          this.rules.carry = [
            { required: true, message: "请输入搬运服务内容", trigger: "blur" }
          ];
          break;
        case "鲜花驿站":
          this.rules.flowerList = [
            {
              required: true,
              label: "花的种类类目",
              validator: validateGroupArray("flowerList"),
              trigger: "change"
            }
          ];
          break;
      }
    },

    // 处理时间变化
    handleTimeChange() {
      if (this.form.timeRange[0] && this.form.timeRange[1]) {
        this.form.time_s =
          this.form.timeRange[0] + " - " + this.form.timeRange[1];
      }
    },

    // 将字符串转换为二维数组
    convertToGroupArray(str) {
      if (!str) {
        return [[{ value: "" }, { value: "" }]];
      }

      // 将字符串按逗号分割成数组
      const items = str.split(",").map(item => ({ value: item.trim() }));
      const groups = [];

      // 每两个元素组成一组
      for (let i = 0; i < items.length; i += 2) {
        const group = [
          items[i],
          items[i + 1] || { value: "" } // 处理奇数个元素的情况
        ];
        groups.push(group);
      }

      // 确保至少有一组
      return groups.length ? groups : [[{ value: "" }, { value: "" }]];
    },

    // 获取详情数据
    getDetail() {
      let self = this;
      self.loading = true;
      School_serviceApi.detail(
        { school_service_id: self.school_service_id },
        true
      )
        .then(res => {
          const data = res.data || {};

          // 转换多组输入框数据
          const goodsList = self.convertToGroupArray(data.goods || "");
          const priceList = self.convertToGroupArray(data.price || "");
          const flowerList = self.convertToGroupArray(data.flower || "");

          // 处理时间范围
          let timeRange = ["", ""];
          if (data.time_s) {
            const timeArr = data.time_s.split(" - ");
            timeRange = [timeArr[0] || "", timeArr[1] || ""];
          }

          self.form = {
            ...data,
            timeRange,
            goodsList,
            priceList,
            flowerList,
            // 确保数组字段存在，避免渲染错误
            image: data.image || [],
            bannar: data.bannar || []
          };

          // 初始化富文本内容
          self.ueditor.text = self.form.intro || "";

          // 设置对应服务类型的验证规则
          self.setDynamicRules();
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
          console.error("获取详情失败:", error);
        });
    },

    // 关闭弹窗
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, type: "" });
    },

    // 取消
    cancelFunc() {
      this.dialogFormVisible("error");
    },

    // 提交表单
    onSubmit() {
      let self = this;
      let form = {
        ...self.form,
        school_service_id: self.school_service_id
      };

      form.time_s = form.timeRange[0] + " - " + form.timeRange[1];

      // 处理二维数组数据，提取所有value值
      if (form.goodsList && form.goodsList.length) {
        form.goods = form.goodsList
          .flat() // 展平二维数组
          .map(item => item.value.trim())
          .filter(Boolean)
          .join(",");
      }

      if (form.priceList && form.priceList.length) {
        form.price = form.priceList
          .flat() // 展平二维数组
          .map(item => item.value.trim())
          .filter(Boolean)
          .join(",");
      }

      if (form.flowerList && form.flowerList.length) {
        form.flower = form.flowerList
          .flat() // 展平二维数组
          .map(item => item.value.trim())
          .filter(Boolean)
          .join(",");
      }

      // 验证图片是否上传
      if (form.image.length <= 0) {
        self.$message({
          message: "请上传图片",
          type: "error"
        });
        return;
      }

      // 获取富文本内容
      form.intro = this.$refs.ue.getUEContent();

      // 表单验证
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          School_serviceApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    // 打开上传图片
    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    // 上传商品图片回调
    returnProductImgsFunc(e) {
      if (!e) {
        this.isProductUpload = false;
        return;
      }

      // 验证图片格式
      const imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
      let isValidFormat = true;

      e.forEach(element => {
        const dataArray = element.file_path.split(".");
        const ext = dataArray[dataArray.length - 1].toLowerCase();
        if (!imgExpt.includes(ext)) {
          isValidFormat = false;
        }
      });

      if (!isValidFormat) {
        this.$message.error("图片类型有误,请选择正确的图片格式");
        return;
      }

      // 根据类型添加图片
      if (this.code === "album") {
        this.form.image = this.form.image.concat(e);
      } else if (this.code === "bannar") {
        this.form.bannar = this.form.bannar.concat(e);
      }

      this.isProductUpload = false;
    },

    // 删除图片
    deleteImg(index, code) {
      if (code === "album") {
        this.form.image.splice(index, 1);
      } else if (code === "bannar") {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
  text-align: center;
  text-decoration: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
  cursor: pointer;
}

.draggable-list .img-select i {
  color: #409eff;
}

.common-button-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

/* 调整输入框组样式 */
.input-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.input-pair {
  display: flex;
  gap: 10px;
  flex: 1;
}

.multi-input {
  flex: 1;
  min-width: 0; /* 确保输入框能正确收缩 */
}

.add-btn {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/school_service/index/part/edit.vue